<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M14.796 13.842a3.115 3.115 0 0 0 .504-1.692A3.153 3.153 0 0 0 12.15 9 3.153 3.153 0 0 0 9 12.15a3.153 3.153 0 0 0 3.15 3.15c.621 0 1.206-.189 1.692-.504l2.304 2.304.954-.954-2.304-2.304Zm-2.646.108c-.99 0-1.8-.81-1.8-1.8s.81-1.8 1.8-1.8 1.8.81 1.8 1.8-.81 1.8-1.8 1.8ZM16.002 1.8l1.098.783-3.492 5.31a4.348 4.348 0 0 0-1.458-.243l3.852-5.85ZM12.15 7.65c-.522 0-1.017.09-1.485.252l-.702-.99-3.069 4.824-2.232-2.673-2.664 4.329L.9 12.6l3.6-5.85 2.25 2.7L9.9 4.5l2.25 3.15Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
